module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAPRJREFUWAljYBgFoyEwGgKjIUBCCPz//58ViBcDcTEJ2qijFGgpDxDvAmIY6AEyGKljOgFTgBaJAfEZmM1Q+hWQViKglXJpoCXKQHwHaimMugdkqFJuOgETgJYYA/FLmK1Q+gKQliSglXJpoCWuQPwZaimM2g9k8FFuOsIErIkIaEk0UMl8IGZFKGX4A2QvBeKfSGIkMxkZGdPxagJaXgzE/4CYJgDdciZ0AXrzWdAtBAZRL9DrL4DiNIkCdPtw8oGOoEsixOkAkATQEQOXDWEuAzpi4AoiJEcMXFGM5IiBq4yQHDFw1THMEaP0aAiMhsCwCwEAHHN7swnrg74AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic_left@4x.png
// module id = 1457
// module chunks = 0